module.exports = __webpack_public_path__ + "f24b8d0238b2e1629f08c65286165ad2.jpg";